<template>
	<div class="dialog__body">
		<slot />
	</div>
</template>
